import { render, staticRenderFns } from "./businessCoupon.vue?vue&type=template&id=1de18096&scoped=true&"
import script from "./businessCoupon.vue?vue&type=script&lang=js&"
export * from "./businessCoupon.vue?vue&type=script&lang=js&"
import style0 from "./businessCoupon.vue?vue&type=style&index=0&id=1de18096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de18096",
  null
  
)

export default component.exports